import ReplaceSwitchModal from './ReplaceSwitchModal'

export default ReplaceSwitchModal
